// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-frag__tabs {
  display: flex;
  gap: 0;
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  margin-bottom: var(--dp-spacing-sm);
}

.dp-frag__tab {
  flex: 1;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.dp-frag__tab:hover {
  color: var(--dp-color-text);
}

.dp-frag__tab--active {
  color: var(--dp-color-primary);
  border-bottom-color: var(--dp-color-primary);
}

.dp-frag__message {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  margin-bottom: var(--dp-spacing-sm);
}

.dp-frag__message--success {
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-frag__message--error {
  background: #ffebee;
  color: #c62828;
}

.dp-frag__message-close {
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  color: inherit;
  padding: 0 2px;
}

.dp-frag__search {
  width: 100%;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  margin-bottom: var(--dp-spacing-xs);
  box-sizing: border-box;
}

.dp-frag__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: var(--dp-spacing-sm);
}

.dp-frag__chip {
  padding: 2px 8px;
  border: 1px solid var(--dp-color-border);
  border-radius: 12px;
  background: var(--dp-color-surface);
  font-size: 11px;
  cursor: pointer;
  color: var(--dp-color-text-secondary);
  transition: all 0.12s;
}

.dp-frag__chip:hover {
  border-color: var(--dp-color-primary);
  color: var(--dp-color-primary);
}

.dp-frag__chip--active {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}

.dp-frag__loading,
.dp-frag__error,
.dp-frag__empty {
  text-align: center;
  padding: var(--dp-spacing-md);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text-secondary);
}

.dp-frag__error {
  color: #c62828;
}

.dp-frag__list {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-xs);
}

.dp-frag__card {
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  padding: var(--dp-spacing-sm);
  background: var(--dp-color-surface);
}

.dp-frag__card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--dp-spacing-xs);
  margin-bottom: 4px;
}

.dp-frag__card-name {
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.dp-frag__card-badge {
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  background: #e3f2fd;
  color: #1565c0;
  white-space: nowrap;
}

.dp-frag__card-desc {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  margin-bottom: 4px;
  line-height: 1.3;
}

.dp-frag__card-meta {
  display: flex;
  gap: var(--dp-spacing-sm);
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  margin-bottom: var(--dp-spacing-xs);
}

.dp-frag__card-version {
  background: #f5f5f5;
  padding: 0 4px;
  border-radius: 3px;
}

.dp-frag__preview {
  background: #fafafa;
  border: 1px solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  padding: var(--dp-spacing-xs);
  margin-bottom: var(--dp-spacing-xs);
}

.dp-frag__preview-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--dp-color-text-secondary);
  margin-bottom: 2px;
}

.dp-frag__preview-text {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text);
  white-space: pre-wrap;
  max-height: 80px;
  overflow-y: auto;
}

.dp-frag__card-actions {
  display: flex;
  gap: var(--dp-spacing-xs);
}

.dp-frag__btn {
  padding: 4px 10px;
  border: none;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
  transition: opacity 0.12s;
}

.dp-frag__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-frag__btn--primary {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
}

.dp-frag__btn--primary:hover:not(:disabled) {
  opacity: 0.9;
}

.dp-frag__btn--secondary {
  background: var(--dp-color-surface);
  color: var(--dp-color-text);
  border: 1px solid var(--dp-color-border);
}

.dp-frag__btn--full {
  width: 100%;
  padding: var(--dp-spacing-sm);
}

/* Save tab */
.dp-frag__save-desc {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  margin: 0 0 var(--dp-spacing-md);
  line-height: 1.4;
}

.dp-frag__label {
  display: block;
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text);
  margin-bottom: 4px;
}

.dp-frag__input,
.dp-frag__select,
.dp-frag__textarea {
  width: 100%;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  margin-bottom: var(--dp-spacing-sm);
  box-sizing: border-box;
  font-family: inherit;
}

.dp-frag__textarea {
  resize: vertical;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/FragmentPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,MAAM;EACN,uEAAuE;EACvE,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,iCAAiC;EACjC,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;EAClD,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;;EAGE,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAChE,yCAAyC;EACzC,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,iCAAiC;EACjC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;EACnC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".dp-frag__tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-frag__tab {\n  flex: 1;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.dp-frag__tab:hover {\n  color: var(--dp-color-text);\n}\n\n.dp-frag__tab--active {\n  color: var(--dp-color-primary);\n  border-bottom-color: var(--dp-color-primary);\n}\n\n.dp-frag__message {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-frag__message--success {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-frag__message--error {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.dp-frag__message-close {\n  background: none;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  color: inherit;\n  padding: 0 2px;\n}\n\n.dp-frag__search {\n  width: 100%;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  margin-bottom: var(--dp-spacing-xs);\n  box-sizing: border-box;\n}\n\n.dp-frag__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-frag__chip {\n  padding: 2px 8px;\n  border: 1px solid var(--dp-color-border);\n  border-radius: 12px;\n  background: var(--dp-color-surface);\n  font-size: 11px;\n  cursor: pointer;\n  color: var(--dp-color-text-secondary);\n  transition: all 0.12s;\n}\n\n.dp-frag__chip:hover {\n  border-color: var(--dp-color-primary);\n  color: var(--dp-color-primary);\n}\n\n.dp-frag__chip--active {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n\n.dp-frag__loading,\n.dp-frag__error,\n.dp-frag__empty {\n  text-align: center;\n  padding: var(--dp-spacing-md);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-frag__error {\n  color: #c62828;\n}\n\n.dp-frag__list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-xs);\n}\n\n.dp-frag__card {\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  padding: var(--dp-spacing-sm);\n  background: var(--dp-color-surface);\n}\n\n.dp-frag__card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: 4px;\n}\n\n.dp-frag__card-name {\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.dp-frag__card-badge {\n  padding: 1px 6px;\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 600;\n  background: #e3f2fd;\n  color: #1565c0;\n  white-space: nowrap;\n}\n\n.dp-frag__card-desc {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  margin-bottom: 4px;\n  line-height: 1.3;\n}\n\n.dp-frag__card-meta {\n  display: flex;\n  gap: var(--dp-spacing-sm);\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n.dp-frag__card-version {\n  background: #f5f5f5;\n  padding: 0 4px;\n  border-radius: 3px;\n}\n\n.dp-frag__preview {\n  background: #fafafa;\n  border: 1px solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  padding: var(--dp-spacing-xs);\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n.dp-frag__preview-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--dp-color-text-secondary);\n  margin-bottom: 2px;\n}\n\n.dp-frag__preview-text {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text);\n  white-space: pre-wrap;\n  max-height: 80px;\n  overflow-y: auto;\n}\n\n.dp-frag__card-actions {\n  display: flex;\n  gap: var(--dp-spacing-xs);\n}\n\n.dp-frag__btn {\n  padding: 4px 10px;\n  border: none;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n  transition: opacity 0.12s;\n}\n\n.dp-frag__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-frag__btn--primary {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n}\n\n.dp-frag__btn--primary:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.dp-frag__btn--secondary {\n  background: var(--dp-color-surface);\n  color: var(--dp-color-text);\n  border: 1px solid var(--dp-color-border);\n}\n\n.dp-frag__btn--full {\n  width: 100%;\n  padding: var(--dp-spacing-sm);\n}\n\n/* Save tab */\n.dp-frag__save-desc {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  margin: 0 0 var(--dp-spacing-md);\n  line-height: 1.4;\n}\n\n.dp-frag__label {\n  display: block;\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text);\n  margin-bottom: 4px;\n}\n\n.dp-frag__input,\n.dp-frag__select,\n.dp-frag__textarea {\n  width: 100%;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  margin-bottom: var(--dp-spacing-sm);\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.dp-frag__textarea {\n  resize: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
